import ReactGA from 'react-ga4'

export const initGA = () => {
  ReactGA.initialize('G-PSL53SFB84')
}

export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path })
}

// Meta Pixel
const META_PIXEL_ID = '1211979767187274'
const META_PIXEL_SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

let metaPixelBootstrapped = false
let metaPixelListenerAdded = false

const ensureMetaPixelStub = () => {
  if (window.fbq) return
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
}

const ensureMetaPixelScript = () => {
  const existingScript =
    document.querySelector('script[data-meta-pixel]') || document.querySelector('script[src*="fbevents.js"]')
  if (existingScript || !document.head) return

  const script = document.createElement('script')
  script.async = true
  script.src = META_PIXEL_SCRIPT_SRC
  script.setAttribute('data-meta-pixel', 'true')
  document.head.appendChild(script)
}

export const initMetaPixel = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  ensureMetaPixelStub()
  ensureMetaPixelScript()

  if (!metaPixelBootstrapped) {
    window.fbq('init', META_PIXEL_ID)
    metaPixelBootstrapped = true
  }

  // Add pageshow listener to handle bfcache restoration
  if (!metaPixelListenerAdded) {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        ensureMetaPixelScript()
        if (window.fbq) {
          window.fbq('track', 'PageView')
        }
      }
    })
    metaPixelListenerAdded = true
  }
}

export const trackMetaPixelPageView = () => {
  initMetaPixel()
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}
